import {
    moderator
  } from "../../js/path";
  let ws = null;
  import axios from "axios";

  export default {
    data() {
      return {
        isClicked: false,
        messageLoading: false,
        selected_user: [],
        joined_person: null,
        loading: false,
        user: {},
        event: {},
        recording: {},
        aggregateddata: {},
        usersLogged: [],
        cmes: [],
        moderators: [],
        normalUsers: [],
        total_users: [],
        messages: [],
        textMessage: "",
        groupId: null,
        websocket_link: "",
        disconnected : false,
        sessionStarted : false,
        startRecording : false,
        selectedCme: {},
      };
    },
  
    async mounted() {
      
      // example: route param se event_id
      const eventId = this.$route.params.id;
      let url = moderator.getMmoderatorUrl + "/" + eventId + '?moderator_id=' + localStorage.getItem('moderator_id');
          const data = await this.getRequest(url);
          // const res = data;
  
          if (data.status) {
            const response = data.response;
  
            this.event = response.event;
            this.recording = response.recording;      
            this.aggregateddata = response.aggregateddata;
            this.usersLogged = response.users_logged;
            this.cmes = response.cmes;
            this.groupId = response.event.live_event_chat_group;
            this.websocket_link = response.websocket_link;
            this.user = response.moderator;
            
            this.normalUsers = this.usersLogged.filter((d) => d?.user?.userData?.type === "member");
            this.moderators = this.usersLogged.filter((d) => d?.user?.userData?.type === "mod");
          }
      
      // this.fetchModerator(eventId);

      if (this.event.display_in_chat_box != null) {
        
        if (this.event.display_in_chat_box.type == "pollscore") {
            this.selectedCme = this.event.display_in_chat_box.data.cme_id;
            this.disabledChat(true);
        } else {
            this.disabledChat(false);
        }
    }
    console.log(this.websocket_link);
    ws = new WebSocket(this.websocket_link);
    
    ws.onopen = (e) => {
        console.log("Connected",e);
        let data = {
            name: this.user.fname,
            room: "chat-live-" + this.groupId,
            user: this.user,
            type: "mod",
            private_msg: this.privateChat != null ? this.privateChat : 0,
        };
        let d = JSON.stringify(data);
        ws.send(`{"action" : "setLoggedIn", "data" : ${d}}`);
    };
    // console.log(this.user);
    
    // ws.onopen = () => {
    //   const payload = {
    //     name: this.user.fname,
    //     room: "chat-live-" + this.groupId,
    //     user: this.user,
    //     type: "mod",
    //     private_msg: this.privateChat ?? 0
    //   };
    
    //   ws.send(JSON.stringify({
    //     action: "setLoggedIn",
    //     data: payload
    //   }));
    // };
    
    ws.onmessage = (e) => {
        let data = JSON.parse(e.data);
        console.log('data',data);
        if (data.publicMessage) {
            let message = data.publicMessage;
            this.addChatMessage(message);
        } else if (data.members) {
            let members = data.members;
            this.total_users = members;
            this.normalUsers = members.filter(
                (d) => d.user.userData.type === "member"
            );
            this.moderators = members.filter(
                (d) => d.user.userData.type === "mod"
            );
        } else if (data.deleteMessage) {
            let temp = this.messages;
            let index = temp.findIndex(
                (msg) => msg.id === data.deleteMessage
            );
            this.messages.splice(index, 1);
        } else if (data.memberInactive) {
            if (data.memberInactive.userData.type == "member") {
                this.normalUsers = this.normalUsers.filter(
                    (d) =>
                        d.user.userData.type === "member" &&
                        data.memberInactive.userData.user_id !=
                            d.user.userData.user_id
                );
            } else {
                this.moderators = this.moderators.filter(
                    (d) =>
                        d.user.userData.type === "mod" &&
                        data.memberInactive.userData.user_id !=
                            d.user.userData.user_id
                );
            }
        } else if (data.blockUser) {
            let temp = this.normalUsers;
            let index = temp.findIndex(
                (mem) =>
                    mem.user.userData.user_id ==
                    data.blockUser.userData.user_id
            );
            console.log(index);
            let d = {
                user: data.blockUser,
            };
            this.normalUsers.splice(index, 1, d);
        }
    };
    ws.onerror = function (e) {
        console.log("Error: " + e.data);
    };
    this.$nextTick(function () {
        this.getMessages();
    });
    ws.onclose = function() {
      this.disconnected = true;
      if(confirm("Please Reload due to inactivity")){
          window.location.reload();
      }
  }
    },
    
  computed: {
    filteredModerators(){
      let tempModerators = this.moderators;
      if (this.searchUser != '' && this.searchUser) {
          tempModerators = tempModerators.filter((mem) => {
              return mem.user.name
                  .toUpperCase()
                  .includes(this.searchUser.toUpperCase())
          });

          tempModerators = tempModerators.sort((a, b) => {
              let fa = a.user.title.toLowerCase(), fb = b.user.title.toLowerCase()

              if (fa < fb) {
                  return -1
              }
              if (fa > fb) {
                  return 1
              }
              return 0
          });
      }
      return tempModerators;
    },

    filteredBlockedUsers(){
      let tempMembers = this.normalUsers;
      let seen = new Set()
      if (this.searchUser != '' && this.searchUser) {
          tempMembers = tempMembers.filter((mem) => {
              return mem.user.name
                  .toUpperCase()
                  .includes(this.searchUser.toUpperCase())
          });

          tempMembers = tempMembers.sort((a, b) => {
              let fa = a.user.name.toLowerCase(), fb = b.user.name.toLowerCase()

              if (fa < fb) {
                  return -1
              }
              if (fa > fb) {
                  return 1
              }
              return 0
          });

      }
      tempMembers = tempMembers.filter(el => {
          let duplicate = seen.has(el.user.userData.user_id)
          seen.add(el.user.userData.user_id)
          return !duplicate && el.user.userData.block == 1;
      })
      return tempMembers;
    },


  },
    methods: {
      setSessionStarted(v) {
        if (v == true && this.sessionStarted == false) {
            // socket.emit('session_started');
            this.sessionStarted = true;
        }
    },
      
    setUpdatedStartSession(){
        this.startRecording = true;
    },
    setUpdatedEndSession(){
        this.stopRecording = true;
    },
    // setDisconnectUsers(){
    //     let _this = this;
    //     axios.post('/setChatInactive',{
    //         live_event_id : this.event.id,
    //     }).then(function(response) {
    //         if(response.data.status){
    //             _this.disconnectAll = true;
    //         }
    //     });
    // },
      async fetchModerator(eventId) {
        this.loading = true;
  
        try {
          let url = moderator.getMmoderatorUrl + "/" + eventId;
          const data = await this.getRequest(url);

          // const res = data;
  
          if (data.status) {
            const response = data.response;
  
            this.event = response.event;
            this.recording = response.recording;
            this.aggregateddata = response.aggregateddata;
            this.usersLogged = response.logged_user;
            this.cmes = response.cmes;
            this.groupId = response.event.live_event_chat_group;
            this.websocket_link = response.websocket_link;
            this.user = response.moderator;
            this.normalUsers = this.usersLogged.filter((d) => d?.user?.userData?.type === "member");
            this.moderators = this.usersLogged.filter((d) => d?.user?.userData?.type === "mod");
  
            
            
          }
        } catch (error) {
          console.error(error);
          this.$toast?.error("Failed to load moderator data");
        } finally {
          this.loading = false;
        }
      },
      disconnectAllUsers() {
        console.log("disconnectAllUsers");
        
        ws.send(`{"action" : "disconnectAllUsers"}`);
      },
      disabledChat(val) {
        this.isClicked = val;
        this.disabled = val;
        
        
    },
      toggleChat(val) {
        this.isClicked = val;
        this.disabled = val;
      },
      async sendMessage() {
        this.loading = true;
        const urlRegex =
    /([a-zA-Z0-9]+:\/\/)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\.[A-Za-z]{2,})(:[0-9]+)?(\/.*)?/;
    console.log(urlRegex);
    

  if (this.disconnected) {
    this.loading = false;
    return;
  }

  if (!this.textMessage || !this.textMessage.trim()) {
    this.loading = false;
    return;
  }

  // 🚫 block URLs (raw text only)
  if (urlRegex.test(this.textMessage)) {
    this.errorMessage = "Urls are not accepted";
    this.loading = false;
    return;
  }

  // ✅ now safe to convert
  this.textMessage = this.extractUrl(this.textMessage);

        try {
          // validation
          if (this.textMessage == null || this.textMessage.trim() === "") {
            this.loading = false;
            return;
          }
console.log('textMessage',this.textMessage);

          let url = moderator.LiveEventMessages;

          const response = await this.postRequest(url, {
            message: this.textMessage,
            id: this.user.link_id,
            sender_id: this.user.id,
            type: "moderator",
            group_id: this.groupId,
            to: this.choosenUser.userData
              ? this.choosenUser.userData.user_id
              : null,
            msg_type: this.msg_type,
          });
          // console.log('response',response);

          // 🔥 SAME AS axios.then(...)
          if (response) {
            let m = response.message;
            console.log('m',m);
            

            this.textMessage = null;

            let d = {
              id: m.id,
              socket_id: m.member.id,
              user: m.member.fname,
              message: m.message,
              type: "mod",
              time: m.time,
              date: m.date,
              starred: m.starred,
              to: this.choosenUser.id,
            };

            // websocket send
            // ws.send(
            //   JSON.stringify({
            //     action: "onMessage",
            //     data: d,
            //   })
            // );
            // websocket send
if (!ws) {
  console.error("❌ WS instance is undefined");
  return;
}

console.log("WS readyState:", ws); 
// 0 = CONNECTING, 1 = OPEN, 2 = CLOSING, 3 = CLOSED

if (ws.readyState !== WebSocket.OPEN) {
  console.error("❌ WebSocket not open");
  return;
}

ws.send(
  JSON.stringify({
    action: "onMessage",
    data: d,
  })
);

console.log("✅ WebSocket message sent");

          }

        } catch (error) {
          console.error("LiveEventMessages error:", error);
        } finally {
          this.loading = false;
        }
      },
      async getMessages() {
        let api = moderator.LiveEventMessages; // "/liveEventmessages"
      
      
        if (this.page > this.lastPage) return;
      
        try {
          this.loading = true;
          
          const res = await this.getRequest(`${api}?socket_id=${this.groupId}&mod=true&page=1`);
      
          // ⚠️ depending on getRequest return structure
          // const res = response;
      
          
          if (res?.data?.length > 0) {
            const newMessages = [...res.data].reverse(); // avoid mutating response

            this.messages.splice(0, 0, ...newMessages);

            console.log('test', this.messages);

            this.lastPage = res.meta.last_page;
            this.page = res.meta.current_page;
          } else {
            console.log("No Messages found.");
          }
      
        } catch (error) {
          console.error("getMessages error:", error);
        } finally {
          this.loading = false;
        }
      },
      addChatMessage(message) {
        this.messages.push(message);
      },
      loadNewMessages() {
          this.getMessages();
      },
      scrollToBottom() {
        const container = this.$refs.msg_history;
        container.scrollTop = container.scrollHeight;
        this.show_new = false;
      },
      triggerPollEvents(event) {
        if (event.type == "openChat") {
            this.disabledChat(false);
            this.setChatDisplayBox(3);
        } else if (event.type == "score") {
            this.selectedCme = event.data.id;
            this.disabledChat(true);
            this.setChatDisplayBox(2, event.data.id);
        } else if (event.type == "poll") {
            this.setChatDisplayBox(1, event.data.id);
        }
        ws.send(
            `{"action": "${event.event}", "data": ${JSON.stringify(
                event.data
            )}}`
        );
    },
  //   blockUser(id) {
  //     this.blockLoading = true;
  //     let _this = this;
  //     axios
  //         .post("/chatBlockUser", {
  //             mem: id,
  //         })
  //         .then(function (response) {
  //             if (response.data.status) {
  //                 let data = {
  //                     socket_id: id,
  //                     event_id: _this.user.link_id,
  //                 };
  //                 ws.send(
  //                     `{"action" : "onBlockUser","data" : ${JSON.stringify(
  //                         data
  //                     )}}`
  //                 );
  //                 _this.blockLoading = false;
  //             }
  //         });
  // },
  async blockUser(id) {
    this.blockLoading = true;

    try {
        let url = moderator.ChatBlockUser; // or "/chatBlockUser"

        const response = await this.postRequest(url, {
            mem: id,
        });
console.log('response',response);
        if (response.status) {
            let data = {
                socket_id: id,
                event_id: this.user.link_id,
            };
console.log('data',data);
            // websocket send
            ws.send(
                JSON.stringify({
                    action: "onBlockUser",
                    data: data,
                })
            );
        }
    } catch (error) {
        console.error("BlockUser error:", error);
    } finally {
        this.blockLoading = false;
    }
  },

  setSelectedUser(v) {
    this.selected_user = v;
  },
  removeSelectedUserMethod() {
    this.selected_user = [];
    this.removeSelectedUser += 1;
  },
  async setChatDisplayBox(score, cme_id = null) {
    try {
      console.log(score, cme_id);
      
      let display = {};
  
      if (score === 1) {
        display = {
          type: "poll",
          data: { cme_id }
        };
      } else if (score === 2) {
        display = {
          type: "pollscore",
          data: { cme_id }
        };
      } else {
        display = {
          type: "chat"
        };
      }
  console.log('display',display);
  
      const url = moderator.setChatDisplayStatus;
      console.log('url',url);
      
      const response = await this.postRequest(url, {
        live_event_id: this.user.link_id,
        display: display
      });
      console.log('response',response);
      
      if (response?.data?.status) {
        console.log("✅ Chat display status updated", response.data);
      } else {
        console.warn("⚠️ Failed to update chat display status", response);
      }
  
    } catch (err) {
      console.error("❌ setChatDisplayBox error:", err);
    }
  },
  
  // onDivInput(e) {
  //   this.myHtmlCode = e.msg;
  //   this.choosenUser = e.user;
  //   this.msg_type = e.msg_type;
  //   this.textMessage = this.myHtmlCode
  //       // .replace(/\<(?:.|\s)*?\>|\<br.*?\>/gi, "\n")
  //       .replace(/<[^>]+>|<br\s*\/?>/gi, "\n")
  //       // .replace(/\<\/(?:.|\s)*?\>/g, "")
  //       .replace(/<\/[^>]+>/g, "")
  //       .trim()
  //       .replace(/\n/g, "<br>");
  //   this.textMessage = this.extractUrl(this.textMessage);
  //   this.sendMessage();
  // },
  onDivInput(e) {
    this.myHtmlCode = e.msg;
    this.choosenUser = e.user;
    this.msg_type = e.msg_type;
  
    let cleanText = this.myHtmlCode
      .replace(/<[^>]+>|<br\s*\/?>/gi, "\n")
      .replace(/<\/[^>]+>/g, "")
      .trim();
  
    this.textMessage = cleanText;
    this.sendMessage(); // validate + send
  },
  
  extractUrl(text) {
    var urlRegex = new RegExp(
        "([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?"
    );
    //var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function (url) {
        var url2 = url;
        if (!/^http:\/\//.test(url)) {
            url2 =
                "http://" +
                url.replace("https://", "").replace("http://", "");
        }
        return (
            '<a href="' +
            url2 +
            '" class="link" target="_blank">' +
            url +
            "</a>"
        );
    });
},
  // deleteMessage(v) {
  //   axios
  //       .post("/deleteChatMessage", {
  //           id: v,
  //       })
  //       .then(function (response) {
  //           if (response.data.status) {
  //               ws.send(`{"action" : "onDeleteMessage", "id" : ${v}}`);
  //           }
  //       });
  // },
  async deleteMessage(v) {
    try {
        let url = moderator.DeleteChatMessage; // adjust key if different

        const response = await this.postRequest(url, {
            id: v,
        });

        if ( response.status) {
            // websocket send
            ws.send(
                JSON.stringify({
                    action: "onDeleteMessage",
                    id: v,
                })
            );
        }
    } catch (error) {
        console.error("DeleteMessage error:", error);
    }
  },

  setStarMessage(v) {
    let _this = this;
    axios
        .post("/starChatMessage", {
            id: v.id,
        })
        .then(function (response) {
            if (response.data.status) {
              console.log(response.data.status);
            }
            _this.messageLoading = !_this.messageLoading;
        });
  },
      
    }
  };